import React, { useMemo } from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { createRouter } from './router'
import { AuthProvider } from './lib/auth.context'
import { Toaster } from 'sonner'
import { ThemeProvider } from './lib/theme-context'

export default function App() {
  const queryClient = useMemo(() => new QueryClient({}), [])
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <HelmetProvider>
          <AuthProvider>
            <RouterProvider router={createRouter()} />
            <Toaster />
          </AuthProvider>
        </HelmetProvider>
        <ReactQueryDevtools />
      </ThemeProvider>
    </QueryClientProvider>
  )
}
